<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="手机系统">
								<a-select v-model="queryParams.phoneOs" allow-clear placeholder="请选择" style="width: 100%">
									<a-select-option value="ANDROID">安卓</a-select-option>
									<a-select-option value="IOS">iOS</a-select-option>
									<a-select-option value="HARMONY">鸿蒙</a-select-option>
									<a-select-option value="UNLIMIT">不限</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="商品类型">
								<a-select v-model="queryParams.type" allow-clear placeholder="请选择" style="width: 100%">
									<a-select-option v-for="o in typeOptions" :key="o.value" :value="o.value">{{ o.label }}</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="货币">
								<a-select v-model="queryParams.currency" allow-clear placeholder="请选择" style="width: 100%">
									<a-select-option value="CNY">人民币</a-select-option>
									<a-select-option value="SCORE">积分</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<template v-if="advanced">
							<a-col :md="10">
								<a-form-item label="时间">
									<a-range-picker v-model="createTime" style="width: 100%" @change="onCreateTime" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span
								class="x-filter-submit-box"
								:style="advanced && { float: 'right', overflow: 'hidden' } || {}"
							>
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left: 8px" @click="rest">重置</a-button>
								<a style="margin-left: 8px" @click="toggleAdvanced">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<div class="x-tool">
				<a-button type="primary" icon="plus" v-has="'/system/productAdd'" @click="add">新增</a-button>
			</div>

			<a-table
				:rowKey="(record) => record.id"
				:columns="tableColumns"
				:loading="tableLoading"
				:dataSource="tableData"
				:pagination="false"
			>
				<template slot="phoneOs" slot-scope="text">
					{{ phoneOsLabel(text) }}
				</template>
				<template slot="type" slot-scope="text">
					{{ typeLabel(text) }}
				</template>
				<template slot="product" slot-scope="record">
					<div class="product-cell">
						<div class="line-main">
							<span>【{{ record.name }}】</span>
							<span v-if="record.digest" class="muted">{{ record.digest }}</span>
							<span v-if="record.isFirst === 'Y'" class="is-first">首次</span>
						</div>
						<span v-if="record.depict" class="muted line-depict">{{ record.depict }}</span>
					</div>
				</template>
				<template slot="price" slot-scope="record">
					{{ priceText(record) }}
				</template>
				<template slot="action" slot-scope="record">
					<a v-has="'/system/productUpdate'" @click="update(record)">修改</a>
					<a-divider type="vertical" />
					<a
						v-if="record.isEnable === 'Y'"
						@click="setEnabled(record.id, 'N')"
					>停用</a>
					<a v-else @click="setEnabled(record.id, 'Y')">启用</a>
				</template>
			</a-table>

			<ProductForm
				ref="ProductForm"
				:visible="formVisible"
				:loading="formLoading"
				:model="formModel"
				@cancel="formCancel"
				@ok="formOk"
			/>

			<div class="x-pagination">
				<a-pagination
					:pageSize="pageSize"
					v-model="pageIndex"
					:total="totalRow"
					:hideOnSinglePage="true"
					show-less-items
					@change="pageChange"
				/>
			</div>
		</a-card>
	</div>
</template>

<script>
import moment from 'moment';
import ProductForm from '@/pages/system/product/ProductForm.vue';
import { productList, productDetail, productAdd, productUpdate, productSetEnabled } from '@/api/system/product';

const typeOptions = [
	{ value: 'RECHARGE_GOLD', label: '充值金币' },
	{ value: 'RECHARGE_VIP', label: '充值会员' },
	{ value: 'EXCHANGE_GOLD', label: '兑换金币' },
	{ value: 'EXCHANGE_VIP', label: '兑换会员' },
	{ value: 'EXCHANGE_CASH', label: '兑换现金' },
];

const tableColumns = [
	{ title: '#', dataIndex: 'id', width: 70, align: 'center' },
	{ title: '手机系统', dataIndex: 'phoneOs', width: 100, align: 'center', scopedSlots: { customRender: 'phoneOs' } },
	{ title: '商品类型', dataIndex: 'type', width: 110, align: 'center', scopedSlots: { customRender: 'type' } },
	{ title: '商品', scopedSlots: { customRender: 'product' }, width: 220, align: 'left' },
	{ title: '价格', scopedSlots: { customRender: 'price' }, width: 120, align: 'center' },
	{ title: '排序', dataIndex: 'seq', width: 80, align: 'center' },
	{ title: '时间', dataIndex: 'created', width: 170, align: 'center' },
	{ title: '操作', scopedSlots: { customRender: 'action' }, width: 160, align: 'center' },
];

export default {
	components: { ProductForm },
	data() {
		return {
			advanced: false,
			queryParams: {},
			totalRow: 0,
			tableColumns,
			tableData: [],
			tableLoading: false,
			pageSize: 20,
			pageIndex: 1,
			createTime: [],
			formVisible: false,
			formLoading: false,
			formModel: null,
			typeOptions,
		};
	},
	created() {
		this.fetchTableData();
	},
	methods: {
		typeLabel(v) {
			const o = this.typeOptions.find((x) => x.value === v);
			return o ? o.label : v || '-';
		},
		phoneOsLabel(v) {
			const m = { ANDROID: '安卓', IOS: 'iOS', HARMONY: '鸿蒙', UNLIMIT: '不限' };
			return m[v] || v || '-';
		},
		priceText(record) {
			if (record.currency === 'CNY') {
				return `${record.price}元`;
			}
			if (record.currency === 'SCORE') {
				return `${record.price}积分`;
			}
			return String(record.price != null ? record.price : '-');
		},
		fetchTableData() {
			this.tableLoading = true;
			this.queryParams.pageSize = this.pageSize;
			this.queryParams.page = this.pageIndex;
			productList(this.queryParams)
				.then((res) => {
					if (!res.isSucceed) {
						this.$message.error(res.message || '加载失败');
						this.tableData = [];
						this.totalRow = 0;
						return;
					}
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList || [];
				})
				.catch(() => {
					this.$message.error('网络异常');
					this.tableData = [];
				})
				.finally(() => {
					this.tableLoading = false;
				});
		},
		toggleAdvanced() {
			this.advanced = !this.advanced;
		},
		onCreateTime(values) {
			if (values && values.length === 2) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			} else {
				delete this.queryParams.startCreateTime;
				delete this.queryParams.endCreateTime;
			}
		},
		pageChange(current) {
			this.pageIndex = current;
			this.fetchTableData();
		},
		rest() {
			this.createTime = [];
			this.queryParams = {};
			this.pageIndex = 1;
			this.fetchTableData();
		},
		add() {
			this.formModel = null;
			this.formVisible = true;
			this.$nextTick(() => {
				if (this.$refs.ProductForm && this.$refs.ProductForm.initForm) {
					this.$refs.ProductForm.initForm();
				}
			});
		},
		update(record) {
			if (!record || !record.id) {
				return;
			}
			this.tableLoading = true;
			productDetail(record.id)
				.then((res) => {
					if (!res.isSucceed) {
						this.$message.error(res.message || '加载详情失败');
						return;
					}
					this.formModel = res.data || {};
					this.formVisible = true;
				})
				.catch(() => {
					this.$message.error('网络异常');
				})
				.finally(() => {
					this.tableLoading = false;
				});
		},
		formCancel() {
			this.formModel = null;
			this.formVisible = false;
			if (this.$refs.ProductForm && this.$refs.ProductForm.initForm) {
				this.$refs.ProductForm.initForm();
			}
		},
		formOk() {
			const formRef = this.$refs.ProductForm;
			if (!formRef || !formRef.$refs.adminForm) {
				return;
			}
			const values = formRef.getFormPayload();
			this.formLoading = true;
			const done = (msg) => {
				this.formVisible = false;
				this.formLoading = false;
				this.formModel = null;
				if (formRef.initForm) {
					formRef.initForm();
				}
				this.fetchTableData();
				this.$message.success(msg);
			};
			const fail = () => {
				this.formLoading = false;
			};
			if (values.id > 0) {
				productUpdate(values)
					.then((res) => {
						if (!res.isSucceed) {
							this.$message.error(res.message || '保存失败');
							fail();
							return;
						}
						done('修改成功');
					})
					.catch(() => {
						this.$message.error('网络异常');
						fail();
					});
			} else {
				productAdd(values)
					.then((res) => {
						if (!res.isSucceed) {
							this.$message.error(res.message || '保存失败');
							fail();
							return;
						}
						done('新增成功');
					})
					.catch(() => {
						this.$message.error('网络异常');
						fail();
					});
			}
		},
		setEnabled(id, enable) {
			productSetEnabled(id, enable).then((res) => {
				if (!res.isSucceed) {
					this.$message.error(res.message || '操作失败');
					return;
				}
				this.fetchTableData();
				this.$message.success(enable === 'Y' ? '已启用' : '已停用');
			});
		},
	},
};
</script>

<style lang="less" scoped>
.product-cell {
	max-width: 220px;
	text-align: left;
	word-break: break-word;
	line-height: 1.45;
}
.product-cell .line-main {
	display: block;
}
.product-cell .line-depict {
	display: block;
	margin-top: 2px;
	margin-left:5px;
}
.product-cell .muted {
	color: #8c8c8c;
	font-size: 12px;
}
.product-cell .is-first {
	color: #f5222d;
	font-weight: 600;
	margin-left: 4px;
}
</style>
